import EcoTab, { EcoTabItemProps } from 'eco-design/elements/eco-tab';
import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';
import { Navigation, Scrollbar, Pagination, EffectFade } from 'swiper';
import { useLang } from '@/i18n';
const FullPowerTrigger = () => {
    const { t } = useLang('Delta3AirStation.FullPowerTrigger');
    const swiperRef = useRef<any>(null);

    const items = [
        {
            tabLabel: t('tab_1'),
            tabValue: 'a',
        },
        {
            tabLabel: t('tab_2'),
            tabValue: 'b',
        },
        {
            tabLabel: t('tab_3'),
            tabValue: 'c',
        },
        {
            tabLabel: t('tab_4'),
            tabValue: 'd',
        },
    ];

    const contentList = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761566914476/Frame%202094654472.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761566914476/Frame%202094654472.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761652265188/fullpower-1-m.jpg',
            desc: t('desc_1'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761566913886/Frame%202094654469.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761566913886/Frame%202094654469.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761652265823/fullpower-2-m.jpg',
            desc: t('desc_2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761566914071/Frame%202094654470%20(1).jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761566914071/Frame%202094654470%20(1).jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761652265578/fullpower-3-m.jpg',
            desc: t('desc_3'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1761566914273/Frame%202094654471.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1761566914273/Frame%202094654471.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1761652265337/fullpower-4-m.jpg',
            desc: t('desc_4'),
        },
    ];

    const [activeItem, setActiveItem] = useState<any>(contentList[0]);
    const [activeTabIndex, setActiveTabIndex] = useState<number>(0);

    const toggleItemHandle = (item: EcoTabItemProps, index: number) => {
        setActiveItem(contentList[index]);
        swiperRef.current.slideToLoop(index);
        setActiveTabIndex(index);
    };

    const onSlideChange = ({ activeIndex, realIndex }: any) => {
        setActiveTabIndex(realIndex);
    };

    return (
        <section className={`${styles.FullPowerTrigger} range3 GtmModuleData-section`} id="List-sence-C" data-section-id="FullPowerTrigger">
            <div className="title-box">
                <div className="label">{t('label')}</div>
                <div className="title">{t('title')}</div>
                <div className="subtitle">{t('subtitle')}</div>
            </div>
            <div className="content-box">
                <div className="security-swiper">
                    <Swiper
                        modules={[Navigation, Pagination, EffectFade]}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        loop={true}
                        effect={'fade'}
                        speed={800}
                        centeredSlides={true}
                        onSlideChange={onSlideChange}
                        pagination
                        spaceBetween={16}
                        slidesPerView={'auto'}
                    >
                        {contentList.map((item, index) => (
                            <SwiperSlide key={index} className="swiper-slide">
                                <div className="fullpower-img-content">
                                    <EcoImg className="swiper-img" pc={item.pc} pad={item.pad} h5={item.h5} />
                                    <div className="fullpower-tips">{item.desc}</div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
                <div className={`content-tab`}>
                    <EcoTab onChange={toggleItemHandle} items={items} theme={'white'} activeIndex={activeTabIndex} />
                </div>
            </div>
        </section>
    );
};

export default FullPowerTrigger;
